import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";

export const InsuranceInfo = ({ insuranceInfo, isPharmacyOwnedByClinic }) => {
  return (
    <>
      <CollapsePanel labelText="Primary Insurance Info" className="detail-grid-large">
        <DetailGrid className="detail-grid-large">
          <DetailGridItem title="Verified Insurance Name" value={insuranceInfo?.verifiedName} />
          <DetailGridItem title="Policy Effective Date" value={insuranceInfo?.effectiveDate} />
          <DetailGridItem title="Employer Name" value={insuranceInfo?.employerName} />
          <DetailGridItem title="Provided Insurance Name" value={insuranceInfo?.name} />
          <DetailGridItem title="Policy End Date" value={insuranceInfo?.policyEndDate} />
          <DetailGridItem title="Funding Type" value={insuranceInfo?.fundingType} />
          <DetailGridItem title="Member Id" value={insuranceInfo?.memberId} />
          <DetailGridItem title="Payor Phone" value={insuranceInfo?.payorPhone} />
          <DetailGridItem title="Benefits Verified" value={insuranceInfo?.benefitsVerified} />
          <DetailGridItem title="Group Id" value={insuranceInfo?.groupId} />
          <DetailGridItem title="Plan Name" value={insuranceInfo?.planName} />
          <DetailGridItem title="Date Verified" value={insuranceInfo?.dateVerified} />
          <DetailGridItem title="Active Coverage" value={insuranceInfo?.activeCoverage} />
          <DetailGridItem title="Plan Type" value={insuranceInfo?.planType} />
        </DetailGrid>
      </CollapsePanel>
    </>
  );
};
